"use strict";
/*
 * Created on 06 03 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("./DataObjectConverter");
/**
 * Implementation of {@link DataObjectConverter} for representation of {@link TimedRecord timed record}.
 *
 * @author JMe
 */


var TimedRecordConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(TimedRecordConverter, _DataObjectConverter_);

  function TimedRecordConverter() {
    _classCallCheck(this, TimedRecordConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(TimedRecordConverter).apply(this, arguments));
  }

  _createClass(TimedRecordConverter, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.fromDate(source.validTo)
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return {
        id: conversions.documentToClassId(source),
        validFrom: conversions.asObject(source, 'validFrom', function (v) {
          return conversions.toDate(v);
        }),
        validTo: conversions.asObject(source, 'validTo', function (v) {
          return conversions.toDate(v);
        })
      };
    }
  }]);

  return TimedRecordConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.TimedRecordConverter = TimedRecordConverter;